<mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"  [expanded]="panelOpenState()" id="main" class="border">
      <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
       <div class="container-fluid" style="background: black;display: flex;align-items: center;justify-content: space-between;">
          
          <h5 class="mb-0 text-white">Reducer Features
          </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
          <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
       </div>
      </mat-expansion-panel-header>
      <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
       <div class="container-fluid" style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">
          
          <h5 class="mb-0 text-white">Reducer Features
          </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
          <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
       </div>
      </mat-expansion-panel-header>
      <div *ngIf="signalStatus==true">
        <div class="card-body">
            <div class="row" [formGroup]="reducerSelectionForm">
                <div class="col-md-6 col-lg-6 border">
                <!-- First Row -->
                <div class="row border">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="form-group row">
                            <label for="inputType" class="col-md-5 col-sm-5 col-form-label">Type of Unit</label>
                            <div class="col-sm-7 col-md-7">
                            <select class="form-control" id="inputType" formControlName="inputType" name="inputType" #inputTypeDropDown (change)="onTypeOfUnitChange($event)">
                                <option [ngValue]="null" selected>--Select--</option>
                                <option *ngFor="let unit of inputTypeOfUnit" [value]="unit.key">{{ unit.value }}</option>
                            </select>
                            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputType')?.hasError('required')" class="text-danger">
                                Please select an option.
                            </div>
                            </div>
                        </div>
                    </div>
                </div><br>



                     <!-- Second Row -->
                    <div class="row border">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group row">
                                    <label for="inputUnitVersion" class="col-md-5 col-sm-5 col-form-label">Unit Version</label>
                                    <div class="col-sm-7 col-md-7">
                                    <select class="form-control" id="inputUnitVersion" formControlName="inputUnitVersion" name="inputUnitVersion" #inputUnitVersionDropDown (change)="onUnitVersionChange($event)">
                                        <option [ngValue]="null" selected>--Select--</option>
                                        <option *ngFor="let unit of inputUnitVersion" [value]="unit.key">{{ unit.value }}</option>
                                    </select>
                                    <div *ngIf="formSubmitted && reducerSelectionForm.get('inputUnitVersion')?.hasError('required')" class="text-danger">
                                        Please select an option.
                                      </div>
                                    </div>
                                </div>
                            </div>
                    </div><br>

                    

 <!-- Third Row -->
 <div class="row border">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group row">
            <label for="inputOutputShaft" class="col-md-5 col-sm-5 col-form-label">Output Shaft</label>
            <div class="col-sm-7 col-md-7">
            <select class="form-control" id="inputOutputShaft" formControlName="inputOutputShaft" name="inputOutputShaft" #inputOutputShaftDropDown (change)="oninputOutputShaftChange($event)">
                <option [ngValue]="null" selected>--Select--</option>
                <option *ngFor="let option of inputOutputShaft" [value]="option.key">{{ option.value }}</option>
            </select>
            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputOutputShaft')?.hasError('required')" class="text-danger">
                Please select an option.
              </div>
            </div>
        </div>
    </div>
</div><br>

<!-- Third Row -->
<div class="row border">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group row">
            <label for="inputBoreDia" class="col-md-5 col-sm-5 col-form-label">Bore Diameter</label>
            <div class="col-sm-7 col-md-7">
            <select class="form-control" id="inputBoreDia" formControlName="inputBoreDia" name="inputBoreDia" #inputBoreDiaDropDown (change)="oninputBoreDiaChange($event)">
                <option [ngValue]="null" selected>--Select--</option>
                <option *ngFor="let option of inputBoreDia" [value]="option.key">{{ option.value }}</option>
            </select>
            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputBoreDia')?.hasError('required')" class="text-danger">
                Please select an option.
              </div>
            </div>
        </div>
    </div>
</div><br>

<!-- Fourth Row -->
<div class="row border">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group row">
            <label for="inputMotorAdaptor" class="col-md-5 col-sm-5 col-form-label">Motor Adaptor</label>
            <div class="col-sm-7 col-md-7">
            <select class="form-control" id="inputMotorAdaptor" formControlName="inputMotorAdaptor" name="inputMotorAdaptor" #inputMotorAdaptorDropDown (change)="oninputMotorAdaptorChange($event)">
                <option [ngValue]="null" selected>--Select--</option>
                <option *ngFor="let option of inputMotorAdaptor" [value]="option.key">{{ option.value }}</option>
            </select>
            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputMotorAdaptor')?.hasError('required')" class="text-danger">
                Please select an option.
              </div>
            </div>
        </div>
    </div>
</div><br>


 <!-- Fifth Row -->
 <div class="row border">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group row">
            <label for="inputAssemblyPosition" class="col-md-5 col-sm-5 col-form-label">Assembly Position</label>
            <div class="col-sm-7 col-md-7">
            <select class="form-control" id="inputAssemblyPosition" formControlName="inputAssemblyPosition" name="inputAssemblyPosition" #inputAssemblyPositionDropDown (change)="oninputAssemblyPositionChange($event)">
                <option [ngValue]="null" selected>--Select--</option>
                <option *ngFor="let option of inputAssemblyPosition" [value]="option.key">{{ option.value }}</option>
            </select>
            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputAssemblyPosition')?.hasError('required')" class="text-danger">
                Please select an option.
              </div>
              
            </div>
        </div>
    </div>
</div><br>

<!-- Sixth Row -->
<div class="row border">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group row">
            <label for="inputSpecialFeature" class="col-md-5 col-sm-5 col-form-label">Special Feature</label>
            <div class="col-sm-7 col-md-7">
            <select class="form-control" id="inputSpecialFeature" formControlName="inputSpecialFeature" name="inputSpecialFeature" #inputSpecialFeatureDropDown (change)="oninputSpecialFeatureChange($event)">
                <option [ngValue]="null" selected>--Select--</option>
                <option *ngFor="let option of inputSpecialFeature" [value]="option.key">{{ option.value }}</option>
            </select>
            <div *ngIf="formSubmitted && reducerSelectionForm.get('inputSpecialFeature')?.hasError('required')" class="text-danger">
                Please select an option.
              </div>
            </div>
        </div>
    </div>
</div><br>

                    <div class="row border">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <div class="col-lg-6">
                                   
                                </div>
                                <div class="col-lg-6">
                                    <input id="Btn_ReducerSize" type="button" value="Proceed" class="button btn btn-primary w-100 m-1 p-1" style="background-color: #59842b" (click)="rgReducerButton()">
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 border" style="display: flex; justify-content: center;">
                    <div class="card" style="border: none;">
                        <!-- <div class="card" style="width: 430px;border: none;"> -->
                        <img class="card-img-top" id="rgImage" [src]=" AssetbasePath + '/Content/FImages/InputType.jpg'" #rgImage alt="Card image cap" >
                      </div>
                </div>
            </div>
        </div>
    
</div>
<div *ngIf="signalStatus==false">
    <h4 style="color: red;">Please proceed from previous step</h4>
   </div>
</mat-expansion-panel>
</mat-accordion>